module.exports = __webpack_public_path__ + "static/media/undraw_medical_research_qg4d.116d4ad4.svg";